var _radialGradient, _radialGradient2, _path, _path2, _path3, _path4, _path5, _radialGradient3, _path6, _path7, _radialGradient4, _path8, _radialGradient5, _path9, _path10, _radialGradient6, _path11, _path12, _radialGradient7, _path13, _radialGradient8, _radialGradient9, _linearGradient, _path14, _path15, _linearGradient2, _path16, _linearGradient3, _path17, _linearGradient4, _path18, _linearGradient5, _path19, _linearGradient6, _path20, _linearGradient7, _path21, _linearGradient8, _path22, _linearGradient9, _path23, _linearGradient10, _path24, _path25, _linearGradient11, _path26, _linearGradient12, _path27, _linearGradient13, _path28, _linearGradient14, _path29, _linearGradient15, _path30, _linearGradient16, _path31, _linearGradient17, _path32, _linearGradient18, _path33, _linearGradient19, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAustraliaPowerball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.6 85.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 49.824,
    cy: 42.609,
    r: 37.391,
    fx: 63.321,
    fy: 18.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#c6c6ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7c8199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#838aa6"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M48.63 7.5c19.2 0 34.77 15.79 34.77 35.28S67.83 78.06 48.63 78.06s-34.77-15.8-34.77-35.28c0-19.49 15.57-35.28 34.77-35.28z",
    fill: "url(#a)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 49.362,
    cy: 21.679,
    r: 23.737,
    fx: 45.604,
    fy: 22.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#c6c6ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    stopColor: "#f5d7dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#c6c6ce"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m71.44 20.71-34.58.9.32-6.45-7.55-3.35s16.83-6.22 28.75-2.54C70.3 12.94 75.62 20.6 71.44 20.71z",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m60.69 55.79.52 6.46c.11.35 1.1 1.88 1.32 1.93.23.05 2.02-7.59 2.02-7.59s-1.57-2.2-3.86-.8zm5.11 10.87-1.17.23-1.34-2c-.07-.17.37-.36.94-1.09l1.72-2.32c.04-.07 5.35-2.22 5.35-2.22l-5.5 7.4zm.39.5-4.42.9s-.19-.01-.23.65l-.39 3.86-3.39-2.71s-.18-.03-.31.08-4.73 3.3-4.73 3.3l-1.47 3.34s7.86.86 12.03-.57c4.17-1.42 7.36-7.36 7.25-7.92s-3.59-1.04-4.34-.93zm-17.13 1.86 5.11-.2c.11.03.73 2.39.73 2.39l-8.98.72-.84-2.1 3.98-.81zm1.73-7.85 3.09 4.46c.1.24.77 2.22.45 2.19-.31-.03-5.37-6.19-5.37-6.19l1.83-.46z",
    style: {
      fill: "#120f35"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m74.4 15.56-.49-1.13s-.49-.11-1.05.1c-.56.2-.92.4-.92.4s.03.8-.27 1.63l-.53 1.33s2.24.94 3.09-.08c.83-1.02.17-2.25.17-2.25z",
    fill: "#343276"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m36.25 14.45 2.59.27s.01.1-.1.36l-.39.9-9.36 1.31c-2.05.45-2.81.82-2.81.82l-.07.83s-.74 1.94-1.73.75c-.98-1.2-.57-3.31-.57-3.31s8.89-2.08 12.44-1.93zm-11.43 12.6.57-.12.69.63s.16 1.93.06 2.19c-.1.25-.7 1.72-1.31.48s-.01-3.18-.01-3.18z",
    style: {
      fill: "#120f35"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m38.7 29.52 1.48-.64-.46.74L25.7 41.53l-.25-1.73z",
    fill: "#2e292e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m67.84 32.38-1.08-1.65-1.28.36.72 16.21 3.01-.39zm-4.59-19.32c0 .07-.07 1.14-.07 1.14s-1.36 1.23-1.68 1.13-5.55-9.59-5.55-9.59 4.58-1.21 7.3 7.32z",
    style: {
      fill: "#120f35"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m67.74 9.8-2.65 2.78c-.91.92-1.78 1.55-1.91 1.61s-1.12-3.45-2.92-5.78-3.4-2.75-3.84-2.67c-.43.08-.62-.08-.62-.08s.55-.32 1.04-.32c.5.02 6.82 1.64 10.9 4.46z",
    fill: "#262ee0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m51.87 12.93.25.27-1.01 1.03L32.6 8.21s.86-.66 1.51-.84c.65-.17 9.15-2.01 17.76 5.56z",
    style: {
      fill: "#120f35"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.12 13.2s-1.04-4.31-2.15-6.21c-1.11-1.89-2.31-2.54-2.31-2.54s-4.11.19-7.12.87c-3.02.69-6.43 2.05-6.43 2.05s3.61-.46 8.85 1.44c5.24 1.91 8.73 4.22 8.9 4.33.16.11.26.12.26.06z",
    fill: "#262ee0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m78.03 30.28-1.33-.66s-.07-.04-.18-.02l-1.2.26c-.21.01-.4.04-.4.04s-.02.05-.01.07c.01.03 3.25 3.48 5.42 6.67 2.18 3.19 3.58 8.79 4.17 9.07s1.47.08 1.36-3.66-5.5-10.58-7.83-11.77zm2.37.64s-.21-.79-.31-2.09-8.86-10.65-8.86-10.65-.2-.25-.04-.39 1.99-1.07 1.99-1.07l1.3-.02s4.02 1.29 6.87 7.23c2.86 5.94 2.32 7.69 2.25 7.69-.07-.01-3.2-.7-3.2-.7z",
    style: {
      fill: "#120f35"
    }
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 53.196,
    cy: 12.409,
    r: 31.354,
    gradientTransform: "matrix(.3431 .9393 -1.1755 .4293 49.533 -42.886)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#c91414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#b91415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a51416"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m50.31 14.87.98-.61s-.18-.39-3.43-2.01c-3.26-1.62-5.31-2.64-8.78-3.68-3.47-1.05-6.28-.6-6.28-.6l-3.49 1.76c-.26.18 1.56-.72 8.77 2.08l9.24 3.35 2.99-.29z",
    fill: "url(#c)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m46.4 14.94-.42-.62s-5.03-2.86-8.96-4.07c-3.93-1.22-6.21-1.25-7.45-.67-1.24.59-1.26 1.7-1.26 1.7s.58.37 1.52.57 1.83-.06 1.83-.06 2.26-.73 5.95.5c3.7 1.23 7.44 3.27 7.44 3.27l1.35-.62z",
    fill: "#87282b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m45.05 15.56.92-1.24 5.32-.06-.93 1.19zm20.44 13.95 1.88-.45a126.72 126.72 0 0 0 9.32 8.96c4.47 4.8 5.77 7.32 5.77 7.32l-1.33.01c0-.01-7.75-10.18-15.64-15.84z",
    style: {
      fill: "#471214"
    }
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 53.196,
    cy: 12.412,
    r: 31.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#c91414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#b91415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a51416"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m71.83 29.21-4.46-.15 8.62 8.52c3.29 3.37 6.43 7.8 6.43 7.8l2.28-.4s-4.44-8.17-12.87-15.77z",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 37.11c-.35-.43-1.78-4.84-1.78-4.84l-3.07 3.64c-.21.04-1.5 10.48.86 10.36 3.27-.16 4.35-8.74 3.99-9.16z",
    style: {
      fill: "#120f35"
    }
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 48.629,
    cy: 41.152,
    r: 38.07,
    gradientTransform: "matrix(1 0 0 1.3749 0 -15.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.682,
    stopColor: "#30339b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f51e7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.59 14.4c1.14.09 4.56 4.28 6.27 6.82 4.13 6.14 6.55 13.56 6.55 21.56 0 21.17-16.92 38.34-37.78 38.34-20.87 0-37.78-17.16-37.78-38.34 0-12.88 6.26-24.28 15.87-31.23.75-.12 2.57-.28 4.94.24 3.14.7 7.18 2.77 7.18 2.93 0 .17-1.35-.03-6.15.57-4.8.59-7.74 1.65-7.74 1.65s.22 1.25.33 5.75l.19 6.93s3.2-.11 8.03-.45c4.84-.34 6.74-.34 6.74-.34L26.2 40.64l-.04 6.04 8.66.04 11.85-9.5 8.29-6.84s.51 4.75.59 8.85l.2 7.41 11.86-.2s.03-5.6-.37-10.43l-.45-5.14s-.31-.44.79.24c1.09.69 5.74 5.18 9.29 9.11 3.55 3.92 4.27 5.12 4.27 5.12l3.57-.36-.11-4.79c-.05-.48-2.55-4.23-4.13-6.41-1.57-2.17-3.76-4.16-3.76-4.16l2.89.23c1.83.14 3.71.76 3.71.76s-.03-.4-.17-.93c-.14-.54-1.03-4.34-2.34-6.49-1.29-2.14-2.14-3.75-3.88-4.82s-3.68-1.53-3.68-1.53-.31.01-.22-.14c.05-.09.3-.31.43-.47.36-.45.58-1.23.14-1.83zM12.07 41.7s1.23-2.02 1.23-2.15-.71-2.7-.63-2.64c.07.06 1.16 1.29 1.18 1.22s.49-3.29.49-3.29l.16 3.21c0 .07 1.52-1.27 1.52-1.27s-.96 2.48-1 2.85 1.45 1.97 1.45 1.97-1.83.03-1.88.22c-.05.2.35 3.25.35 3.25s-1.08-2.64-1.09-2.46c0 .18-1.03 2.86-1.03 2.86l.24-3.6c0-.07-.08-.12-.29-.14-.2-.04-.7-.03-.7-.03zm34.81 28.77 7.46-2.64s.26-.1-.25-.74c-.5-.64-3.91-5.32-3.91-5.32s-.08-.15.23-.04 7.23 2.89 7.36 2.89.15-.13.37-.48c.21-.35 3.33-7.9 3.33-7.9l1.01 7.8s.06.3.3.2 7.33-3.83 7.33-3.83l-5.41 6.43s-.27.09.31.26l4.68 1.38-6.64 1.64c-.15.03-.2.31-.22.53l-.69 4.34-3.58-2.73s-.13-.11-.41.14c-.28.26-5.79 3.65-5.79 3.65l2.52-4.75c.07-.08.04-.08-.24-.1-.29-.04-7.76-.73-7.76-.73z",
    fill: "url(#e)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.81 36.03c-.09 2.47-.48 4.46-1.16 6.08l-.07-1.92c-.05-.48-2.55-4.23-4.13-6.41-1.57-2.17-3.76-4.16-3.76-4.16l2.89.23c1.83.14 3.71.76 3.71.76s-.03-.4-.17-.93c-.14-.54-1.03-4.34-2.34-6.49-1.29-2.14-2.14-3.75-3.88-4.82s-3.68-1.53-3.68-1.53-.31.01-.22-.14c.05-.09.3-.31.43-.47.37-.44.59-1.22.15-1.83 1.14.09 4.56 4.28 6.27 6.82 2.93 4.37 5.01 9.39 5.96 14.8v.01zm-3.21 9.16c-2.14 2.11-5.33 3.14-9.54 3.8-10.05 1.57-30.52 2.07-41.63 1.53-8.34-.41-15.05-1.43-18.22-6.04.29-.78.65-1.77.65-1.87.01-.17 1.09 2.46 1.09 2.46s-.4-3.06-.35-3.25c.06-.2 1.88-.22 1.88-.22s-1.49-1.6-1.45-1.97 1-2.85 1-2.85-1.52 1.34-1.52 1.27-.16-3.21-.16-3.21l-.49 3.29c-.02.07-1.11-1.16-1.18-1.22-.08-.06.63 2.51.63 2.64s-1.23 2.15-1.23 2.15.5-.01.71.02c.21.02.29.07.29.14a148.14 148.14 0 0 1-.14 2.18c-1.05-1.72-1.64-3.92-1.69-6.73a38.456 38.456 0 0 1 15.48-25.76c.75-.12 2.57-.28 4.94.24 3.14.7 7.18 2.77 7.18 2.93 0 .17-1.35-.03-6.15.57-4.8.59-7.74 1.65-7.74 1.65s.22 1.25.33 5.75l.19 6.93s3.2-.11 8.03-.45c4.84-.34 6.74-.34 6.74-.34L26.2 40.64l-.04 6.04 8.66.04 11.85-9.5 8.29-6.84s.51 4.75.59 8.85l.2 7.41 11.86-.2s.03-5.6-.37-10.43l-.45-5.14s-.31-.44.79.24c1.09.69 5.74 5.18 9.29 9.11 3.55 3.92 4.27 5.12 4.27 5.12l1.46-.15z",
    fill: "#1d219e"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 53.193,
    cy: 12.409,
    r: 31.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#c91414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#b91415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a51416"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m67.67 15.15-1.75 1.47s.95.11 2.07.35l1.47.29s1.21-.25 2.33-1.51c1.12-1.25 1.26-1.67 1.29-1.87.03-.21-.04-.35-.13-.42l-1.7-1.37c-.16-.15-.3-.18-.43-.17-.11 0-1.95 2.53-3.15 3.23z",
    fill: "url(#f)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.93 13.45s2.89-1.81 2.92-1.51c.03.29-.36.74-1.92 2.32s-3.01 2.35-3.01 2.35l1.8-1.8c.52-.57.74-.97.74-.97l-.53-.39z",
    fill: "#87282b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.12 16.4s-1.14-.45-1.94-.59l-1.68-.27-1.58 1.08 3.55.64c.19.03 1.33-.52 1.65-.86zM60.47 45.21l-2.7 1.29-.98-.08s.09-8.28-.9-16.7c-.98-8.42-2.44-14.67-4.21-18.91s-4.02-6.36-4.02-6.36l1.52-.01s3.87 2.58 5.95 6.88 5.95 16.34 5.34 33.89z",
    style: {
      fill: "#471214"
    }
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 53.194,
    cy: 12.409,
    r: 31.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#c91414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#b91415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a51416"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.18 18.73s15.91-2.81 33-1.94 21.01 3.88 21.01 3.88c1.28 1.48 2.96 5.03 3.58 7.75-2.91-1.48-12.45-2.44-22.99-2.68-13.47-.31-28.65.48-34.41 1.46l-.19-8.47z",
    fill: "url(#g)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m80.02 28.83 2.76-.42s-.32-1.73-15.63-3.4-27.49-.28-32.75.31c-5.25.59-9.02 1.86-9.02 1.86l.93.5c5.65-.94 20.81-1.57 33.82-1.21 8.86.27 16.81 1.09 19.89 2.36z",
    style: {
      fill: "#471214"
    }
  })), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 53.195,
    cy: 12.409,
    r: 31.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#c91414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#b91415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a51416"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.66 46.38s-.45-18.03-2.17-25.37c-1.71-7.35-3.74-11.96-5.14-13.65-1.33-1.6-2.39-2.16-2.5-2.22a38.69 38.69 0 0 0-6.68-.7c.13.08 2.74 1.64 4.68 8.19 2 6.73 3.09 15.6 3.57 22.95s.34 10.91.34 10.91l7.9-.11z",
    fill: "url(#h)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 53.196,
    cy: 12.41,
    r: 31.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#c91414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#b91415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a51416"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M49.25 28.7 34.28 40.43l-8.12 6.25.03-4.13 9.13-7.4 7.72-6.36s.02-.07.26-.07l5.93-.13c.04.01.09.05.02.11z",
    fill: "url(#i)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 52.595,
    y1: 41.917,
    x2: 52.51,
    y2: 49.343
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1c78"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m25.9 41.53-2.12 4.58c-1.09 1.04 2.74 4.05 7.65 4.4 4.91.36 26.78-.2 38.06-.75 10.26-.5 11.82-3.86 12.01-4.46l-.37.04s-.63-1.05-3.64-4.42l-9.98.12c.1 3 .09 5.39.09 5.39l-11.86.2-.15-5.45-14.05.17-6.72 5.37-8.66-.04.03-5.15h-.29z",
    fill: "url(#j)",
    style: {
      fillRule: "evenodd"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.15 46.4c-.3 0-.55.23-.58.52l-.53 5.41-1.22-4.91a.58.58 0 0 0-.18-.3l-.54-.47a.575.575 0 0 0-.38-.14l-2.75.03-.82.04c-.21.01-.4.14-.5.33l-2.37 4.94c.07-.42.07-.85 0-1.27-.17-1.58-1.22-2.98-2.67-3.55-.66-.26-1.59-.38-2.86-.38-1.37 0-2.99.16-4.23.42l-.41.08c-.24.05-.43.25-.46.5l-.12.97a3.17 3.17 0 0 0-.73-.64c-1.23-.96-2.96-1.16-4.2-1.16h-.1c-1.07.01-2.23.13-3.59.35a.6.6 0 0 0-.41-.16l-2.39.07-6.29.09a.603.603 0 0 0-.29-.08l-3.85.06c-.06 0-.12.01-.18.03l-.24.08h-.27a.59.59 0 0 0-.56.41l-.53 1.73-.06-.43a.58.58 0 0 0-.57-.5l-3.68.03c-.09 0-.17.02-.24.05l-.14.07h-.14c-.24 0-.45.14-.54.36l-.08.21-.07-1.34a.58.58 0 0 0-.58-.55l-4.45.03-.99.12a.59.59 0 0 0-.51.64l.02.14c-1.03-.73-2.36-1.1-3.97-1.1h-.23c-1.13.02-2.21.24-3.06.6-1.11.35-2.09.93-2.93 1.74l-.16.16c-.89-1.29-2.42-2.09-4.09-2.09l-2.25.05a38.3 38.3 0 0 0 2.89 10.6 7.6 7.6 0 0 0 1.07-.45c.08.56.23 1.08.43 1.55.47 1.08 1.14 1.91 2.01 2.47a.61.61 0 0 0 .16.12l.16.08.11.07c.06.04.13.06.2.08l-.01.01c.05.03.11.05.17.06.01 0 .02.01.03.01.07.05.14.09.23.11l.16.03c.03.02.06.03.1.05.05.02.09.04.14.04l.12.02.32.08.12.03c.05.02.15.03.22.04.49.08 1.04.12 1.64.12h.22l.28.01h.26c1.49-.03 2.82-.38 3.93-1.03A7.59 7.59 0 0 0 28.82 59l.17-.3.26 2.39.1.85c.03.29.28.51.58.51h3.49l.78-.1c.2-.02.37-.15.46-.33l1.08-2.38.25 1.72.06.5c.03.29.28.52.58.52l3.55-.02.77-.1c.21-.03.39-.16.47-.36l1.38-3.51-.39 2.54c-.02.11 0 .23.04.33l.32.7a.57.57 0 0 0 .53.34l7.21-.15-.31-.42s-.08-.15.23-.04l1.13.45 1.36-.03c.02.01 4.03-.01 4.03-.01a.59.59 0 0 0 .58-.51l.22-1.81.61 1.4.06.11.32.44c.09.12.21.18.35.21l2.4-5.75.74 5.75 1.27-.01c.1 0 .2-.03.29-.08l2.52.1.81-.02 3-1.57-1.17 1.39.87-.19c.37-.1.76-.24 1.13-.4l.01.02c.1.19.3.3.51.3l4.16-.02a.58.58 0 0 0 .53-.34l1.05-2.29h1.5l.15 1.17a.56.56 0 0 0 .15.32l.6.64c.11.12.26.19.43.19l1.78-.01a38.46 38.46 0 0 0 4.46-14.78l-2.13.04zm-60.31 8.54c-.2.96-.57 1.58-.87 1.96-.17.07-.41.12-.65.12-.32 0-.57-.08-.62-.12-.04-.04-.41-.39-.06-2.08.19-.94.79-1.96 1.65-1.97h.05a5.1 5.1 0 0 0 .22.07l.07.04v.18c0 .19.09.35.23.45.01.05.03.09.05.14l.01.17c0 .05.01.09.02.14-.01.28-.04.59-.1.9z",
    fill: "#231f74"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m5.87 60.13 1.88-12.64 2.1-.26 4.6-.1c1.81 0 3.33 1.03 3.98 2.51.21-.27.43-.51.67-.74.77-.74 1.68-1.29 2.7-1.6.83-.35 1.82-.55 2.9-.57h.23c2.02 0 3.54.62 4.54 1.84l.18.23-.19-1.77.99-.12 4.38-.03.21 3.96 1.07-2.65h.27l.26-.12 3.68-.03.43 2.99L42 46.81h.37l.33-.12 3.84-.06.08.08 6.51-.1 2.39-.07-.03.25.06-.01c1.51-.27 2.81-.41 3.98-.43h.11c1.14 0 2.74.18 3.84 1.04.46.3.83.72 1.08 1.22a4.72 4.72 0 0 1 .34.9l.1-.73.26-2.1.41-.09c1.2-.25 2.78-.4 4.11-.4 1.18 0 2.07.12 2.65.34 1.25.49 2.15 1.7 2.3 3.07.16.98-.11 2-.75 2.9.29.32.48.72.6 1.17l3.63-7.55.82-.04 2.73-.02.54.47 2.03 8.19.85-8.77 4.35-.02.18.91-.76 7.98 3.23-.2.62-8.89 4.56.02-.53 8.75 4.22-.21-.21 3.24-.27.96-7.99.62h-.01l-7.52.28-.06.17-3.97.02-.6-.64-.21-1.68h-2.39l-1.2 2.63-4.16.02-.28-.51c-.52.28-1.06.48-1.52.61-.96.26-2.02.37-3.36.37-.91 0-1.83-.05-2.69-.11l-.1-.01-.03.1-4.29.04-.32-.44-1.46-3.36-.49 3.92-3.97.01-.01-.01-9.67.2-.32-.7 1.19-7.7-3.29 8.37-.77.1-3.48.02-.06-.5-.53-3.71-1.9 4.19-.78.1-3.42-.01-.1-.85-.52-4.84c-.23.96-.55 1.81-.98 2.53-.63 1.05-1.46 1.89-2.48 2.48-1.02.6-2.25.92-3.64.95h-.75c-.57 0-1.1-.04-1.57-.13h-.08l-.03-.02-.16-.03-.3-.07-.16-.03-.01-.01h-.02l-.04-.02-.13-.04-.18-.04-.03-.04-.1-.04c-.03-.01-.07-.02-.1-.04h-.03l-.08-.05-.06-.03h-.03l-.11-.07-.23-.12v-.02c-.81-.49-1.45-1.26-1.89-2.27-.28-.67-.44-1.45-.47-2.32-1.37 1.04-3.19 1.34-4.93 1.43l-.4 3.83-1.17.09-4.42.09.16-1.07zm57.06-5.3c.36.61.68 1.32.95 2l.5-3.55a5.59 5.59 0 0 1-1.45 1.55zm-38.6-3.59c-1.2 0-1.99 1.22-2.24 2.43-.28 1.36-.18 2.28.27 2.65.19.15.58.26.99.26.38 0 .76-.09 1.02-.24.37-.43.83-1.16 1.07-2.3a5.2 5.2 0 0 0 .1-1.16l-.02-.02-.01-.24-.01-.02v-.08l-.04-.03v-.21l-.01-.05-.01-.01-.02-.11h-.17v-.35h-.01l-.06-.11-.02-.02v-.02l-.01-.03-.01-.02-.01-.01-.02-.04-.05-.02-.01-.02-.17-.09v-.01l-.28-.07v-.03c-.03-.01-.05-.01-.08-.02l-.19-.01zm24.87 4.85 4.7-.07.69-5.14-4.55.06-.02.1 4.44-.04-.76 4.44-4.43.07-.07.58zm9.95-4.37a2.94 2.94 0 0 0 .85-.21c.27-.11.34-.31.36-.41.02-.13-.01-.26-.09-.33-.06-.06-.21-.12-.59-.12a5.09 5.09 0 0 0-.39.02l-.14 1.05zm10.05-.9.48-.02c.27-.01.5-.11.61-.26.06-.07.06-.13.06-.14a.98.98 0 0 0-.38-.06h-.43l-.27.01-.07.47z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 96.454,
    y1: 59.252,
    x2: 96.582,
    y2: 48.112
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5318d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3beef"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.34 46.32h3.4l-.53 8.78 4.21-.21-.16 2.53-.14.51-7.19.56-.38-.95z",
    fill: "url(#k)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 88.79,
    y1: 59.165,
    x2: 88.918,
    y2: 48.025
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5318d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3beef"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m85.71 46.53 3.34-.01.07.36-.81 8.57 4.76-.3-.13 3.14-.5.24-7.8.28-.08-.53z",
    fill: "url(#l)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 13.119,
    y1: 58.295,
    x2: 13.247,
    y2: 47.156
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5318d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3beef"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m9.91 47.79 4.54-.1c2.12-.04 4.04 1.77 3.69 4.12-.58 3.91-3.56 4.69-6.97 4.8l-.4 3.85-.69.05L8.25 48l1.66-.21zm1.82 5.6.62-.01c.48-.01.83-.14 1.06-.38.22-.24.35-.54.4-.9.04-.36-.01-.66-.15-.9-.15-.24-.45-.36-.92-.35l-.72.02-.29 2.52z",
    fill: "url(#m)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 23.85,
    y1: 58.417,
    x2: 23.979,
    y2: 47.278
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5318d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3beef"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.82 54.05c.25-2.09.99-3.74 2.2-4.93s2.77-1.8 4.67-1.84c1.95-.04 3.38.5 4.3 1.63.91 1.12 1.25 2.72.99 4.79-.19 1.5-.57 2.73-1.15 3.7a6.44 6.44 0 0 1-2.27 2.28c-.94.55-2.06.84-3.36.86-1.32.03-2.39-.18-3.2-.62s-1.42-1.16-1.84-2.15c-.41-.97-.52-2.22-.34-3.72zm3.71-.5c-.24 1.2-.32 2.57.47 3.21.67.55 2.26.54 2.97-.16.49-.48 1.07-1.35 1.33-2.64.22-1.1.06-2.05-.24-2.58-.31-.53-.89-.69-1.59-.73-1.62-.08-2.65 1.45-2.94 2.9z",
    fill: "url(#n)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 38.143,
    y1: 58.582,
    x2: 38.271,
    y2: 47.443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5318d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3beef"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m30.5 47.47 3.75-.02.38 7.13 1.84-5.82.27-.13 3.04-.02.86 5.95 1.83-7.17.34-.12 3.49-.05.17.18-5.01 12.75-.42.05-2.9.01-.03-.4-.46-6-2.91 6.43-.42.06-2.87-.01-.04-.33-1.34-12.44z",
    fill: "url(#o)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 49.658,
    y1: 58.715,
    x2: 49.786,
    y2: 47.575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5318d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3beef"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m46.79 47.4 8.07-.25-.43 3.15-4.87.07-.23 1.26 4.44-.05-.56 3.29-4.46.07-.2 1.74 5.4-.08-.41 3.35-8.87.18-.09-.19z",
    fill: "url(#p)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 59.187,
    y1: 58.824,
    x2: 59.315,
    y2: 47.685
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5318d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3beef"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m54.16 59.94-.19-.13 1.85-12.33c1.28-.23 2.6-.4 3.89-.41 1.5-.02 3.58.28 4.33 1.8a4.24 4.24 0 0 1 .44 1.78c.03 1.71-.81 3.1-2.35 4.01.95 1.34 1.74 3.79 2.03 4.81l-.1.31-3.56.03-.11-.14-1.31-3.03c-.32-.74-.52-1.11-.73-1.09l-.38.03-.54 4.37-3.27-.01zm4.32-7.61c.5-.01 1.12-.03 1.74-.29.81-.33.92-1.27.43-1.71-.44-.39-1.28-.23-1.88-.22l-.29 2.22z",
    fill: "url(#q)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 78.674,
    y1: 59.049,
    x2: 78.802,
    y2: 47.909
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5318d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3beef"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.72 56.67h-3.27l-1.2 2.63-3.44.02-.16-.29 5.93-12.34.47-.02.32.23 2.17-.26.23.2 2.93 11.81-.12.32-3.31.02-.3-.32-.25-2zm-.52-3.13-.49-2.06-.97 2.05 1.46.01z",
    fill: "url(#r)"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 69.107,
    y1: 58.937,
    x2: 69.235,
    y2: 47.798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5318d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3beef"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65.79 47.37c1.95-.41 5.15-.59 6.44-.09 1.89.75 2.83 3.25.94 5.3 1.41.8 1.1 3.62.27 4.97-.56.91-1.85 1.59-2.92 1.88-1.76.47-3.79.38-5.86.24l-.55-.37 1.68-11.93zm2.73 4.04 1.18-.04c1.42-.05 1.76-1.67.27-1.63l-1.2.04-.25 1.63zm-.62 4.92 1.37-.03c1.78-.04 1.91-2 .21-1.93l-1.38.05-.2 1.91z",
    fill: "url(#s)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m93.92 46.57 2.69-.16-.6 8.97 4.29-.27-.18 2.82-7.12.39zm-7.96-.03 3.08-.01-.97 9.23 4.55-.18-.2 2.92-7.54.16zM8.25 48l5.49-.11c2.43-.05 3.95 1.91 3.61 4.25-.58 3.92-3.6 4.04-6.86 4.42l-.41 3.96-3.69.07L8.25 48zm2.63 5.56.9-.02c.71-.01 1.23-.15 1.56-.41.32-.27.52-.6.58-1.01.06-.4-.02-.73-.23-1s-.65-.4-1.34-.39l-1.05.02-.42 2.81zm6.41.59c.25-2.07.99-3.68 2.2-4.85s2.77-1.78 4.67-1.82c1.95-.04 3.39.5 4.3 1.61.91 1.1 1.25 2.68.99 4.71-.18 1.47-.57 2.69-1.15 3.65-.58.95-1.34 1.7-2.27 2.24-.94.54-2.06.83-3.36.85-1.32.03-2.39-.18-3.2-.61-.81-.44-1.42-1.14-1.84-2.11-.41-.97-.53-2.19-.34-3.67zm3.51-.45c-.27 1.29-.35 2.76.51 3.45.73.58 2.46.58 3.24-.17.54-.51 1.16-1.44 1.45-2.83.24-1.18.07-2.21-.26-2.77-.33-.57-.96-.74-1.73-.79-1.77-.1-2.89 1.55-3.21 3.11zm9.27-6.18 3.63.05.26 7.44 2.51-6.25 2.86.04.83 6.01 2.27-7.42 3.45-.12-4.78 12.77-2.98.03-.89-6.21-2.84 6.29-2.95.06zm16.45-.22 7.99-.12-.35 3.07-5.01.01-.22 1.67 4.49-.02-.44 2.85-4.46.06-.38 2.21 5.5-.13-.36 2.95-8.7.09zm7.46 12.51 1.67-12.46c1.27-.23 2.6-.4 3.89-.42 1.5-.02 3.58.28 4.32 1.8a4.11 4.11 0 0 1 .43 1.78c.04 1.71-.9 3.38-2.54 4.11 1.06 1.47 1.94 4.22 2.13 5.02l-3.49.02-1.31-3.34c-.3-.75-.28-1.01-.97-.97l-.31.02-.55 4.42-3.27.02zm4.23-7.25c.49-.01 1.32.02 1.94-.22.92-.36 1.14-1.41.57-2.05-.4-.44-1.54-.34-2.14-.32l-.37 2.59zm22.89 3.95h-3.65l-1.2 2.63-3.15.02 5.96-12.49 2.48-.02 2.93 12.18h-3l-.37-2.32zm-.47-2.78-.75-3.17-1.65 3.13 2.4.04zm-14.84-6.57c1.95-.41 5.15-.59 6.44-.09 1.89.75 2.89 3.49.74 5.57 1.46 1.07 1.2 3.2.26 4.87-.53.94-1.57 1.49-2.64 1.77-2.05.53-4.22.19-6.28.04l1.48-12.16zm2.52 4.43h1.34c1.6 0 2.01-1.84.32-1.84h-1.35l-.31 1.84zm-.62 5.08h1.57c2.04 0 2.25-2.49.3-2.45l-1.58.03-.29 2.42z",
    fill: "#fff"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 96.812,
    y1: 58.094,
    x2: 96.812,
    y2: 46.811
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f51e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc5f3"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m94.22 46.82 2.32-.01-.55 8.85 4.26-.31-.12 2.33-6.75.41z",
    fill: "url(#t)"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 88.924,
    y1: 58.349,
    x2: 88.924,
    y2: 46.927
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f51e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc5f3"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m86.19 46.93 2.62.02-.65 9.01 4.45-.15-.17 2.4-7.2.14z",
    fill: "url(#u)"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 11.69,
    y1: 60.209,
    x2: 11.69,
    y2: 48.214
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f51e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc5f3"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m8.2 48.32 5.23-.1c2.33-.04 3.79 1.8 3.45 4.02-.56 3.7-3.84 3.82-6.96 4.18l-.4 3.74-3.09.06 1.77-11.9zm5.72 3.7c.03-.35-.05-.66-.24-.9a.824.824 0 0 0-.45-.29c-.24-.2-.58-.36-.95-.36h-1.42l-.43 3.34c1.19-.03 3.61.07 3.49-1.79z",
    fill: "url(#v)"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    gradientUnits: "userSpaceOnUse",
    x1: 23.131,
    y1: 60.445,
    x2: 23.131,
    y2: 47.741
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f51e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc5f3"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.68 52.3c.51-1.13 1.23-2.12 1.94-2.81 1.16-1.12 2.49-1.72 4.3-1.75 1.87-.04 3.24.47 4.11 1.54.87 1.06 1.19 2.57.95 4.51-.18 1.41-.54 2.58-1.09 3.5-.56.91-1.28 1.63-2.17 2.15-.9.52-2.89.98-4.14 1-.22.01-.43 0-.63-.01-.56-.1-1.05-.27-1.48-.49-.81-.44-1.42-1.14-1.84-2.11s-.53-2.2-.35-3.67c.09-.67.22-1.29.4-1.86zm8.43.5c-.03-.59-.18-1.09-.37-1.42a1.36 1.36 0 0 0-.6-.54c-.64-.69-1.72-.82-2.86-.21-.81.44-1.41 1.26-1.77 2.15-.62 1.51-.74 3.73.51 4.7.42.32 1.18.46 1.93.39 1.96-.17 2.81-1.67 3.19-3.44.12-.64.08-1.17-.03-1.63z",
    fill: "url(#w)"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 37.885,
    y1: 59.961,
    x2: 37.885,
    y2: 47.648
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f51e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc5f3"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m30.34 47.82 3.03.01.32 8.32 2.88-7.06 2.52.04.83 6.68 2.68-8.13 2.83-.03-4.62 12.15-2.72.01-.86-5.95-.09-.65-3.09 6.71-2.64.04-1.07-9.98z",
    fill: "url(#x)"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    gradientUnits: "userSpaceOnUse",
    x1: 49.505,
    y1: 59.75,
    x2: 49.505,
    y2: 47.455
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f51e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc5f3"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m46.6 47.59 7.66-.14-.29 2.49-5.01.04-.26 2.11h4.45l-.41 2.45-4.44.02-.47 2.75 5.48-.17-.3 2.46-8.26.15z",
    fill: "url(#y)"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    gradientUnits: "userSpaceOnUse",
    x1: 59.138,
    y1: 59.497,
    x2: 59.138,
    y2: 47.279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f51e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc5f3"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m54.3 59.5 1.57-11.77c1.19-.21 2.42-.43 3.63-.44 1.98-.02 4.59.77 4.48 3.4-.08 1.91-1.12 3.34-2.62 3.93.68.46 2.06 3.97 2.23 4.72l-2.88.02-1.49-3.41c-.33-.76-.45-.94-1.26-.9l-.37.02L57 59.5h-2.7zm3.58-6.59c.89-.02 2.52.07 3.16-.9.39-.59.33-1.4-.1-1.86-.51-.54-1.92-.36-2.67-.34l-.39 3.1z",
    fill: "url(#z)"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 78.918,
    y1: 59.016,
    x2: 78.918,
    y2: 47.007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f51e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc5f3"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m81.24 56.22-3.79.1-1.23 2.65-2.68.04 5.66-11.99 2.25-.02 2.86 11.63h-2.54l-.53-2.41zm-.3-2.17-.93-3.86-1.82 3.82 2.75.04z",
    fill: "url(#A)"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 69.288,
    y1: 59.314,
    x2: 69.288,
    y2: 47.163
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f51e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc5f3"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1 47.51c1.76-.38 4.72-.52 5.89-.05 1.72.7 2.81 3.12.68 5.19.78.72 1.05 1.53 1.01 2.36-.1 2.17-1.5 3.52-3.11 4-1.89.57-3.96.22-5.83.08l1.36-11.58zm1.88 4.38h1.65c1.98 0 2.49-2.53.4-2.53h-1.68l-.37 2.53zm-.56 5.12 1.88-.04c2.45-.06 2.7-3.1.37-3.01l-1.89.08-.36 2.97z",
    fill: "url(#B)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.18 44.26c-.9-.03-1.91-.18-2.7-1.06-.23-.26-.41-.57-.53-.97-.17-.56-.17-1.06-.16-1.54v-4.17h2.79v4.21c0 .71.18.74.69.74h.13v-4.95h2.79v6.2l.01.84-.26.17c-.04.03-.22.14-.5.2l-.15.04c-.36.09-1.11.29-1.96.29h-.15zm12.49.03c-.17 0-.34-.02-.51-.05-.83-.15-1.51-.62-1.9-1.32-.37-.64-.38-1.23-.39-1.79l-.17-6.19 2.8-.3.02 1.89 2.11-.01-.01 2.63-2.02.01.05 1.86c.01.24.06.53.26.57l.2.02c.4 0 .8-.16.8-.16l.63-.25.54 2.39-.41.2c-.04.02-1.01.5-2 .5zm16.9.17c-.21-.02-.42-.05-.62-.09-1-.21-1.65-.65-2-1.34-.35-.68-.35-1.35-.36-1.99v-.29l-.21-6.68 2.79-.31.01 1.13.33 6.68a.3.3 0 0 0 .11.06.72.72 0 0 0 .19.02h.59l-.01.59c-.01.31-.03 1.09-.19 1.77l-.12.5-.51-.05zm-14.28-.34v-6.98l.28-.17c.06-.03.61-.35 1.87-.5a5.36 5.36 0 0 1 .76-.05c.66 0 1.22.12 1.66.35l.39.2-.09.43-.51 2.26-.67-.35c-.11-.05-.45-.2-.77-.2a.59.59 0 0 0-.14.02v4.98h-2.78zm15.25-.02-.27-7.38h2.79l.27 7.38zm12.59-3.84c-.03-.8-.17-.8-.49-.8l.3 4.81-2.78-.04-.31-5.84-.04-.99.36-.16c.81-.37 2.23-.39 2.39-.39 1.19 0 1.9.27 2.55.94.23.23.42.55.54.93.19.54.2 1.02.21 1.49l.01.17.26 3.85-2.73.09-.27-4.06z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M68.57 37.1c-.86 0-1.6-.69-1.68-1.58-.04-.44.1-.88.39-1.2a1.46 1.46 0 0 1 1.1-.48c.86 0 1.6.69 1.68 1.57.04.45-.1.88-.39 1.2-.28.32-.67.49-1.1.49zm-38.42 5.04h-2.34l-.63 1.97h-3.12l.28-.78 3.67-8.93h2.32L34 44.1l-3.18.01-.67-1.97zm-.9-2.65-.31-.91-.29.91h.6zm13.89 4.8a5.96 5.96 0 0 1-.49-.02c-.57-.02-1.51-.34-1.61-.38l-.47-.16.52-2.98.75.53s.51.34 1.3.34h.02c-.03-.02-.35-.16-.35-.16-.62-.27-1.74-.77-1.99-1.8-.29-1.21-.04-2.12.75-2.72.78-.61 1.49-.61 2.17-.62h.16c.84 0 1.81.46 1.91.52l.41.2-.57 2.49-.67-.37c-.15-.09-.64-.3-1.04-.3-.04 0-.13.01-.13.01l.24.12c.98.42 2.02.87 2.31 1.74.3.89.23 2.12-.62 2.87-.53.46-1.41.69-2.6.69zm16.92 0c-2.3-.04-2.99-1.06-3.16-1.91-.24-1.2.04-2.24.76-2.82l-.5-2.63.5-.15c.05-.02 1.13-.34 2.19-.34l.29.01c1.14.07 2.05.63 2.55 1.57.35.66.36 1.65.37 2.44l.01.49.02 2.39v.4l-.38.14c-.04.02-1.13.41-2.53.41h-.12zm.02-2.96a.5.5 0 0 0-.33.1c-.07.05-.08.08-.08.08 0 .03.08.12.15.15.01.01.09.03.3.03 0 0 .11 0 .16-.01l-.01-.34c-.06 0-.13-.01-.19-.01zm13.45 2.97c-1.69 0-2.67-.62-2.91-1.84-.31-1.57.26-2.37.8-2.77l-.14.07-.62-2.69.51-.16c.05-.02 1.25-.39 2.31-.39l.26.01c1.11.07 1.99.63 2.48 1.58.33.65.35 1.62.36 2.39l.01.52.05 2.47.01.5-.49.08c-.07.02-1.37.23-2.63.23zm-.14-2.52c.01 0 .11.03.4.03h.05v-.36c-.04-.01-.08-.01-.12-.01a.57.57 0 0 0-.31.08c-.08.05-.08.09-.08.11 0 .07.04.13.06.15zm-.45-2.63c-.16.01-.33.04-.51.09a3.86 3.86 0 0 1 .51-.09z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M37.96 37.11h1.63v5.61l.01.53s-.1.07-.3.11-1.11.34-2.11.31-1.71-.23-2.29-.87c-.2-.22-.32-.49-.4-.75-.16-.54-.14-1.01-.14-1.56v-3.4h1.63v3.63c0 1.39.82 1.39 1.97 1.28v-4.89zm9.33-1.64 1.63-.17.02 1.82h2.11l-.01 1.47H49l.06 2.45c.02.49.18 1.03.74 1.12.61.11 1.32-.18 1.32-.18l.29 1.29s-1.18.58-2.14.4c-.64-.12-1.19-.47-1.51-1.04-.33-.59-.3-1.11-.32-1.74l-.15-5.42zm16.68-.88 1.62-.18c.01 1.01-.02 6.9.43 7.47.11.14.29.29.5.32.1.02.2.03.3.03-.01.33-.04 1.05-.18 1.65a5.21 5.21 0 0 1-.57-.09c-.64-.13-1.28-.39-1.6-1.04-.33-.66-.29-1.33-.3-2.04l-.2-6.12zm-9.48 4.19v4.76h-1.62v-6.07s.46-.28 1.63-.42 1.8.09 2.09.24l-.34 1.52s-.58-.31-1.15-.26a1.02 1.02 0 0 0-.61.23zm13.38-1.48h1.63l.23 6.22H68.1zm11.44 6.39-1.62-.02-.28-5.3-.03-.59c.55-.25 1.58-.34 2.16-.34.96-.01 1.55.17 2.13.76.2.2.33.46.41.71.18.51.17.97.19 1.5l.22 3.27-1.57.05-.23-3.49c-.05-1.34-.59-1.43-1.7-1.29l.32 4.74zm-10.93-9.26c.56 0 1.05.47 1.1 1.05s-.36 1.05-.91 1.05c-.56 0-1.05-.47-1.1-1.05-.05-.59.35-1.05.91-1.05zm-40.37.54c-.05-.05-3.12 8.55-3.12 8.55h1.87l.63-1.97h3.18l.67 1.97 1.92-.01-3.24-8.54h-1.91zm2.05 5.1h-2.21l1-3.14.14.01 1.07 3.13zm11.17 3.28.28-1.59s.63.44 1.63.44 1.07-.26 1.03-.54c-.03-.28-.67-.51-1.12-.72-.45-.2-1.48-.61-1.67-1.4-.19-.8-.15-1.6.54-2.13.68-.53 1.27-.49 1.98-.5.72-.01 1.65.45 1.65.45l-.3 1.29s-.83-.46-1.52-.36c-.7.1-.72.34-.72.51.01.17-.01.36.8.71.8.35 1.77.75 1.99 1.4.22.64.22 1.64-.46 2.25-.68.6-2.15.56-2.66.53-.5-.01-1.45-.34-1.45-.34zm16.87-4.56-.28-1.45s1.22-.37 2.28-.3c1.05.06 1.71.58 2.07 1.26.35.68.28 1.97.31 2.69l.02 2.35s-1.07.39-2.44.37c-1.36-.02-2.39-.4-2.6-1.44-.21-1.05.03-1.9.63-2.31s1.23-.42 1.77-.41.96.21.96.21.09-.94-.61-1.22c-.69-.28-1.54-.03-2.11.25zm2.76 3.42-.02-1.28s-.84-.43-1.45.04c-.61.46-.2 1.08.21 1.24s1.26 0 1.26 0zm10.82-3.29-.33-1.45s1.34-.42 2.36-.36c1.01.07 1.64.59 1.99 1.27s.27 1.96.31 2.68l.05 2.44s-1.3.21-2.53.21-2.13-.32-2.34-1.37.02-1.79.59-2.21c.62-.45 1.81-.55 2.52-.29 0 0 .06-.88-.62-1.15-.67-.26-1.45-.05-2 .23zm2.74 3.44v-1.34s-.77-.35-1.34.03c-.58.38-.31 1.11.08 1.26.39.16 1.26.05 1.26.05z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustraliaPowerball);
export default __webpack_public_path__ + "static/media/australia_powerball.48fe3e6e71cb447909e36d2a47211b90.svg";
export { ForwardRef as ReactComponent };